import { mapDTO } from '@twistezo/ts-dto-mapper'

import { FilteringRuleForTable } from '../types'
import { FilteringRuleSliceDTO } from './types'

type From = FilteringRuleSliceDTO
type To = FilteringRuleForTable

export const fromDTO = (from: From): To => {
  return mapDTO<From, To>({ from }).transform((filteringRule: From): To => {
    const { applicableDomains, blockedCount, enabled, id, name, updatedAt } = filteringRule

    return {
      applicableDomains,
      blockedCount,
      enabled,
      id,
      name,
      updatedAt: new Date(updatedAt),
    }
  })
}
